// source: MessageDataProto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.live.netty.protobuf.gencode.MessageData', null, global);
goog.exportSymbol('proto.com.live.netty.protobuf.gencode.MessageData.ClientType', null, global);
goog.exportSymbol('proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType', null, global);
goog.exportSymbol('proto.com.live.netty.protobuf.gencode.MessageData.MessageType', null, global);
goog.exportSymbol('proto.com.live.netty.protobuf.gencode.MessageData.UserType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.live.netty.protobuf.gencode.MessageData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.live.netty.protobuf.gencode.MessageData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.live.netty.protobuf.gencode.MessageData.displayName = 'proto.com.live.netty.protobuf.gencode.MessageData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.toObject = function(opt_includeInstance) {
  return proto.com.live.netty.protobuf.gencode.MessageData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.live.netty.protobuf.gencode.MessageData.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messagedatatype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    companyid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    liveid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    livename: jspb.Message.getFieldWithDefault(msg, 5, ""),
    clienttype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    from: jspb.Message.getFieldWithDefault(msg, 7, ""),
    fromtype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    fromaccount: jspb.Message.getFieldWithDefault(msg, 9, ""),
    fromlevel: jspb.Message.getFieldWithDefault(msg, 10, ""),
    fromname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    fromimage: jspb.Message.getFieldWithDefault(msg, 12, ""),
    to: jspb.Message.getFieldWithDefault(msg, 13, ""),
    totype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    toaccount: jspb.Message.getFieldWithDefault(msg, 15, ""),
    tolevel: jspb.Message.getFieldWithDefault(msg, 16, ""),
    toname: jspb.Message.getFieldWithDefault(msg, 17, ""),
    toimage: jspb.Message.getFieldWithDefault(msg, 18, ""),
    messagetype: jspb.Message.getFieldWithDefault(msg, 19, 0),
    messageid: jspb.Message.getFieldWithDefault(msg, 20, ""),
    message: jspb.Message.getFieldWithDefault(msg, 21, ""),
    msgseq: jspb.Message.getFieldWithDefault(msg, 22, 0),
    receivetime: jspb.Message.getFieldWithDefault(msg, 23, ""),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    notice: jspb.Message.getFieldWithDefault(msg, 25, ""),
    extendMap: (f = msg.getExtendMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData}
 */
proto.com.live.netty.protobuf.gencode.MessageData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.live.netty.protobuf.gencode.MessageData;
  return proto.com.live.netty.protobuf.gencode.MessageData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData}
 */
proto.com.live.netty.protobuf.gencode.MessageData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType} */ (reader.readEnum());
      msg.setMessagedatatype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompanyid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLiveid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLivename(value);
      break;
    case 6:
      var value = /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.ClientType} */ (reader.readEnum());
      msg.setClienttype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 8:
      var value = /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} */ (reader.readEnum());
      msg.setFromtype(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromaccount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromlevel(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromimage(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    case 14:
      var value = /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} */ (reader.readEnum());
      msg.setTotype(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setToaccount(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTolevel(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setToname(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setToimage(value);
      break;
    case 19:
      var value = /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.MessageType} */ (reader.readEnum());
      msg.setMessagetype(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMsgseq(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivetime(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotice(value);
      break;
    case 26:
      var value = msg.getExtendMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.live.netty.protobuf.gencode.MessageData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.live.netty.protobuf.gencode.MessageData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessagedatatype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getLiveid();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getLivename();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClienttype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFromtype();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getFromaccount();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFromlevel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFromname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFromimage();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTotype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getToaccount();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTolevel();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getToname();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getToimage();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMessagetype();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getMsgseq();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getReceivetime();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getNotice();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getExtendMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(26, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * @enum {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType = {
  LOGIN: 0,
  LOGIN_ACK: 1,
  ALIVE: 2,
  SINGLE: 3,
  SERVICE_SINGLE: 4,
  ALL: 5,
  MESSAGE_UP: 6,
  DELETE_MESSAGE: 7,
  MESSAGE_ACK: 8,
  MESSAGE_SIGN: 9,
  LINE: 10,
  NOT_LINE: 11,
  CROWD_OUT: 12,
  USER_UPDATE: 13,
  ANONYMOUS_USER_OUT: 14,
  SILENCE: 15,
  NOT_SILENCE: 16,
  LIVE_SILENCE: 17,
  LIVE_NOT_SILENCE: 18,
  BLACK: 19,
  NOT_BLACK: 20,
  WHITE: 21,
  NOT_WHITE: 22,
  RULE_SEND: 23,
  NOTICE: 24,
  JSON_MESSAGE: 25,
  LIVE_FINISH: 26,
  MESSAGE_SILENCE_NOTICE: 27,
  RULE_HIT_NOTICE: 28
};

/**
 * @enum {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.ClientType = {
  SYSTEM_USER: 0,
  FRONT_USER: 1
};

/**
 * @enum {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.UserType = {
  USER_A: 0,
  USER_N: 1,
  USER_SIMULATE: 2,
  CUSTOMER: 3,
  CUSTOMER_SERVICE: 4,
  ANALYST: 5,
  MANAGER: 6
};

/**
 * @enum {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.MessageType = {
  TEXT: 0,
  PICTURE: 1,
  FILE: 2
};

/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MessageDataType messageDataType = 2;
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getMessagedatatype = function() {
  return /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData.MessageDataType} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setMessagedatatype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 companyId = 3;
 * @return {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setCompanyid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 liveId = 4;
 * @return {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getLiveid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setLiveid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string liveName = 5;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getLivename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setLivename = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ClientType clientType = 6;
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData.ClientType}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getClienttype = function() {
  return /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.ClientType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData.ClientType} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setClienttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string from = 7;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional UserType fromType = 8;
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData.UserType}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFromtype = function() {
  return /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFromtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string fromAccount = 9;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFromaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFromaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fromLevel = 10;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFromlevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFromlevel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string fromName = 11;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFromname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFromname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string fromImage = 12;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getFromimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setFromimage = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string to = 13;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional UserType toType = 14;
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData.UserType}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getTotype = function() {
  return /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData.UserType} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setTotype = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string toAccount = 15;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getToaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setToaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string toLevel = 16;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getTolevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setTolevel = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string toName = 17;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getToname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setToname = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string toImage = 18;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getToimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setToimage = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional MessageType messageType = 19;
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData.MessageType}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getMessagetype = function() {
  return /** @type {!proto.com.live.netty.protobuf.gencode.MessageData.MessageType} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.com.live.netty.protobuf.gencode.MessageData.MessageType} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setMessagetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string messageId = 20;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setMessageid = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string message = 21;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint64 msgSeq = 22;
 * @return {number}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getMsgseq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setMsgseq = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string receiveTime = 23;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getReceivetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setReceivetime = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool success = 24;
 * @return {boolean}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string notice = 25;
 * @return {string}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getNotice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.setNotice = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * map<string, string> extend = 26;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.getExtendMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 26, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.live.netty.protobuf.gencode.MessageData} returns this
 */
proto.com.live.netty.protobuf.gencode.MessageData.prototype.clearExtendMap = function() {
  this.getExtendMap().clear();
  return this;};


goog.object.extend(exports, proto.com.live.netty.protobuf.gencode);
